import React from 'react';
import moment from 'moment';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
import SidebarLogo from '../Image/SideBarIcon.png';

// Create styles for React-PDF
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 12,
    fontFamily: 'Helvetica',
  },
  container: {
    maxWidth: '100%',
    backgroundColor: '#fff',
    padding: 20,
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 5,
  },
  logo: {
    width: '20%',
    objectFit: 'contain',
  },
  title: {
    textAlign: 'center',
    marginBottom: 10,
    fontSize: 25,
    fontWeight: 'bold',
  },
  divider: {
    borderBottom: '0px solid #ccc',
    marginBottom: 10,
    marginTop: 10,
  },
  table: {
    width: '100%',
    marginBottom: 10,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '0px solid #ddd',
  },
  tableHeaderCell: {
    border: '0px solid #ddd',
    padding: 8,
    backgroundColor: '#136bb963',
    color: '#000000',
    fontWeight: 'bold',
  },
  tableCell: {
    border: '0px solid #ddd',
    padding: 8,
  },
  tableCell2: {
    flex: 2,
  },
  tableCell1: {
    flex: 1,
  },
  tableCell4: {
    flex: 4,
  },
  tableCell5: {
    flex: 5,
  },
  textLeft: {
    textAlign: 'left',
  },
  textCenter: {
    textAlign: 'center',
  },
  textRight: {
    textAlign: 'right',
  },
  bold: {
    fontWeight: '400',
  },
  noObjectionHeader: {
    border: '0px solid #ddd',
    padding: 8,
    backgroundColor: '#136bb963',
    color: '#000000',
    textAlign: 'left',
    fontWeight: 'bold',
    width: '100%',
  },
  noObjectionContent: {
    border: '0px solid #fff',
    padding: 20,
    backgroundColor: '#fff',
    textAlign: 'left',
    width: '100%',
  },
  signatureRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #ddd',
  },
  signatureCell: {
    border: '0px solid #ddd',
    padding: 10,
    textAlign: 'left',
    backgroundColor: '#136bb963',
    color: '#000000',
    fontWeight: 'bold',
    flex: 1,
  },
  signatureValueCell: {
    border: '0px solid #ddd',
    padding: 10,
    textAlign: 'left',
    flex: 1,
  },
  signatureEmptyCell: {
    border: '0px solid #ddd',
    height: 50,
    flex: 1,
  },
  footer: {
    marginTop: 10,
    textAlign: 'center',
  },
  footerText: {
    fontWeight: 'bold',
    marginBottom: 5,
  },
  image: {
    width: '80%',
    objectFit: 'contain',
  },
});

// PDF Document Component
const PdfTemplates = ({ voucherData }) => (
  <Document>
    <Page size="A4" style={styles.page} margin={{top: 5, bottom: 5, left: 5, right: 5}}>
      <View style={styles.container}>
        {/* Logo */}
        <View style={styles.logoContainer}>
          <Image src={SidebarLogo} style={styles.logo} />
        </View>

        {/* Title */}
        <Text style={styles.title}>WINNING GIFT VOUCHER</Text>

        {/* First Table - Payment To, Voucher No., Date */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Payment To</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Voucher No.</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Date</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.payment_to || ''}</Text>
            </View>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.voucher_no || ''}</Text>
            </View>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.date ? moment(voucherData.date).format("DD-MM-YYYY") : ''}</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Seller name</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>EID/Passport No.</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Purchase Date</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.seller_name || ''}</Text>
            </View>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.document_no || ''}</Text>
            </View>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.purchase_date ? moment(voucherData.purchase_date).format("DD-MM-YYYY") : ''}</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Ticket ID</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Game Name</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Contact No.</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.order_id || ''}</Text>
            </View>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.game_name || ''}</Text>
            </View>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.contact_no || ''}</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={[styles.tableHeaderCell, styles.tableCell2, styles.textLeft]}>
              <Text style={styles.bold}>Area</Text>
            </View>
          </View>

          <View style={styles.tableRow}>
            <View style={[styles.tableCell, styles.tableCell2, styles.textLeft]}>
              <Text>{voucherData?.area || '--'}</Text>
            </View>
          </View>

        </View>

        {/* Second Table - Description, No. of winning, Amount */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={[styles.tableHeaderCell, styles.tableCell4, styles.textLeft]}>
              <Text style={styles.bold}>Description</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell1, styles.textCenter]}>
              <Text style={styles.bold}>No. of winning</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell1, styles.textRight]}>
              <Text style={styles.bold}>Amount</Text>
            </View>
          </View>
          {voucherData?.winnerList && voucherData.winnerList.length > 0 && voucherData.winnerList.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <View style={[styles.tableCell, styles.tableCell4, styles.textLeft]}>
                <Text>Winning Amount-{item?.amount || ''}</Text>
              </View>
              <View style={[styles.tableCell, styles.tableCell1, styles.textCenter]}>
                <Text>{item?.qty || ''}</Text>
              </View>
              <View style={[styles.tableCell, styles.tableCell1, styles.textRight]}>
                <Text>AED {item?.total || ''}</Text>
              </View>
            </View>
          ))}
          <View style={styles.tableRow}>
            <View style={[styles.tableHeaderCell, styles.tableCell5, styles.textLeft]}>
              <Text style={styles.bold}>Net amount</Text>
            </View>
            <View style={[styles.tableHeaderCell, styles.tableCell1, styles.textRight]}>
              <Text style={styles.bold}>AED {voucherData?.total_amount || ''}</Text>
            </View>
          </View>
        </View>

        <View style={styles.divider} />

        {/* Third Table - No Objection Letter and Signatures */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.noObjectionHeader}>
              <Text style={styles.bold}>No Objection Letter</Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.noObjectionContent}>
              <Text>
                I <Text style={styles.bold}>{voucherData?.payment_to || ''}</Text> holding {voucherData?.document_type || ''} : <Text style={styles.bold}>{voucherData?.document_no || ''}</Text> do hereby declare and confirm that I have received the above draw amount as cash from U WINN LLC.
              </Text>
            </View>
          </View>
          <View style={styles.signatureRow}>
            <View style={styles.signatureCell}>
              <Text style={styles.bold}>Received By</Text>
            </View>
            <View style={styles.signatureCell}>
              <Text style={styles.bold}>Prepared By</Text>
            </View>
            <View style={styles.signatureCell}>
              <Text style={styles.bold}>Checked By</Text>
            </View>
            <View style={styles.signatureCell}>
              <Text style={styles.bold}>Authorized By</Text>
            </View>
          </View>
          <View style={styles.signatureRow}>
            <View style={styles.signatureValueCell}>
              <Text>{voucherData?.received_by || ''}</Text>
            </View>
            <View style={styles.signatureValueCell}>
              <Text>{voucherData?.prepared_by || ''}</Text>
            </View>
            <View style={styles.signatureValueCell}>
              <Text>{voucherData?.checked_by || ''}</Text>
            </View>
            <View style={styles.signatureValueCell}>
              <Text>{voucherData?.authorized_by || ''}</Text>
            </View>
          </View>
          <View style={styles.signatureRow}>
            <View style={styles.signatureEmptyCell}>  <Image src={voucherData?.signature?.signature} style={styles.image} /> </View> 
            <View style={styles.signatureEmptyCell} />
            <View style={styles.signatureEmptyCell} />
            <View style={styles.signatureEmptyCell} />
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>U WINN L.L.C-FZ</Text>
          <Text>-- Thank You --</Text>
        </View>
      </View>
    </Page>
    {voucherData?.doc?.doc && (
      <Page size="A4" style={styles.page} margin={{top: 5, bottom: 5, left: 5, right: 5}}>
          <View style={styles.container}>
              <Image src={voucherData.doc.doc} style={styles.image} />
          </View>
      </Page>
    )}
    {voucherData?.order_slip?.order_slip && (
      <Page size="A4" style={styles.page} margin={{top: 5, bottom: 5, left: 5, right: 5}}>
          <View style={styles.container}>
              <Image src={voucherData.order_slip.order_slip} style={styles.image} />
          </View>
      </Page>
    )}
    {voucherData?.redeem_slip?.redeem_slip && (
      <Page size="A4" style={styles.page} margin={{top: 5, bottom: 5, left: 5, right: 5}}>
          <View style={styles.container}>
              <Image src={voucherData.redeem_slip.redeem_slip} style={styles.image} />
          </View>
      </Page>
    )}
    {voucherData?.other_attachment?.other_attachment && (
      <Page size="A4" style={styles.page} margin={{top: 5, bottom: 5, left: 5, right: 5}}>
          <View style={styles.container}>
              <Image src={voucherData.other_attachment.other_attachment} style={styles.image}  />
          </View>
      </Page>
    )}
    {voucherData?.images?.images && (
      <Page size="A4" style={styles.page} margin={{top: 5, bottom: 5, left: 5, right: 5}}>
          <View style={styles.container}>
              <Image src={voucherData.images.images} style={styles.image}  />
          </View>
      </Page>
    )}
    {voucherData?.images2?.images2 && (
      <Page size="A4" style={styles.page} margin={{top: 5, bottom: 5, left: 5, right: 5}}>
          <View style={styles.container}>
              <Image src={voucherData.images2.images2} style={styles.image}  />
          </View>
      </Page>
    )}
   
  </Document>
);

export default PdfTemplates;

